const _temp0 = require("./components/clipboard.js");
const _temp1 = require("./components/params_input.js");
const _temp2 = require("./components/tooltip.js");
module.exports = {
  "clipboard": _temp0,
  "params_input": _temp1,
  "tooltip": _temp2
}